<!--
 * @Descripttion: 修改密码页面(登录用户直接修改,无需旧密码)
 * @Author: congz
 * @Date: 2020-08-09 12:53:22
-->
<template>
  <div class="user-pass" id="user-pass" name="user-pass">
    <div class="user-pass-layout">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="user-pass-content">
            <div class="extra"></div>
            <div class="user-pass-title">
              <p>Change password
              </p>
            </div>
            <div class="user-pass-form">
              <el-form :model="form" status-icon :rules="rules" ref="form" label-width="80px">
                <el-form-item label="Password" prop="password">
                  <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password" prop="password_confirm">
                  <el-input type="password" v-model="form.password_confirm" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('form')">Save</el-button>
                  <el-button @click="resetForm('form')">Reset</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="extra"></div>
            <div class="extra"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as userAPI from '@/api/users'
export default {
  name: 'UpdatePass',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      } else {
        if (this.form.password_confirm !== '') {
          this.$refs.form.validateField('password_confirm')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.form.password) {
        callback(new Error('The password entered twice is inconsistent!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        password: '',
        password_confirm: ''
      },
      rules: {
        password: [{ validator: validatePass, trigger: 'blur' }],
        password_confirm: [{ validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  methods: {
    submitForm(formName) {
      var self = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          userAPI
            .changePassword({ old_password: '', password: self.form.password })
            .then(res => {
              if (res.status === 200) {
                self.notifySucceed('Password changed successfully')
                self.resetForm('form')
              } else {
                self.notifyError('Password change failed', res.msg)
              }
            })
            .catch(error => {
              self.notifyError('Password change failed', error)
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.user-pass-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.user-pass-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.user-pass-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.user-pass-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.extra {
  height: 10px;
}
.user-pass-form {
  width: 500px;
  margin-left: 20px;
}
</style>
<!--
 * @Descripttion: 
 * @Author: congz
 * @Date: 2020-08-09 12:53:22
 * @LastEditors: congz
 * @LastEditTime: 2020-08-09 21:31:44
-->
<template>
  <div class="user-pass" id="user-pass" name="user-pass">
    <div class="user-pass-layout">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="user-pass-content">
            <div class="extra"></div>
            <div class="user-pass-title">
              <p>Change password
              </p>
            </div>
            <div class="user-pass-form" v-if="this.$store.getters.getUser.email">
              <el-form :model="form" status-icon :rules="rules" ref="form" label-width="80px">
                <el-form-item label="Password" prop="password">
                  <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="Confirm Password" prop="password_confirm">
                  <el-input type="password" v-model="form.password_confirm" autocomplete="off"></el-input>
                </el-form-item>
                <p
                  style="margin-left:20px;margin-bottom:10px;color:#757575;font-size:15px"
                >{{message}}</p>
                <el-form-item>
                  <el-button
                    type="primary"
                    @click="submitForm('form')"
                    :disabled="cannotClick"
                  >{{content}}</el-button>
                  <el-button @click="resetForm('form')">Reset</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="bind-email" v-else>
              <span>Please go first</span>
              <router-link to="/center" class="bind-email-href">Personal Center</router-link>
              <span>Bind email</span>
            </div>
            <div class="extra"></div>
            <div class="extra"></div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as userAPI from '@/api/users'
export default {
  name: 'UpdatePass',
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the password'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('The password length should be between 8 and 16'))
      } else {
        if (this.form.password_confirm !== '') {
          this.$refs.form.validateField('password_confirm')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.form.password) {
        callback(new Error('The password entered twice is inconsistent!'))
      } else {
        callback()
      }
    }
    return {
      form: {
        password: '',
        password_confirm: '',
        user_id: 0,
        email: '',
        operation_type: 0
      },
      rules: {
        password: [{ validator: validatePass, trigger: 'blur' }],
        password_confirm: [{ validator: validatePass2, trigger: 'blur' }]
      },
      content: 'Send verification email',
      cannotClick: false,
      totalTime: 30,
      message: 'We will send a verification email to the account binding email, which will change the account password'
    }
  },
  methods: {
    //按钮点击计时器
    countDown() {
      if (this.cannotClick) return //改动的是这两行代码
      this.cannotClick = true
      this.content = this.totalTime + 's After Resent'
      let clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + 's After Resent'
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = 'Resend verification email'
          this.message =
            'We will send a verification email to the account binding email, which will change the account password'
          this.totalTime = 30
          this.cannotClick = false //这里重新开启
        }
      }, 1000)
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.countDown()
          this.form.operation_type = 3
          this.form.user_id = this.$store.getters.getUser.id
          this.form.email = this.$store.getters.getUser.email
          userAPI.sendEmail(this.form).then(res => {
            if (res.status === 200) {
              this.message =
                'The verification email has been sent to your email and is valid for 15 minutes. If you have not received it, please check your spam folder. If you still have not received it, please resend it'
            } else {
              this.notifyError('Sending email failed', res.msg)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.user-pass-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.user-pass-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.user-pass-title {
  height: 100px;
  display: flex;
  align-items: center;
}
.user-pass-title p {
  font-size: 30px;
  color: #757575;
  margin-left: 50px;
}
.extra {
  height: 10px;
}
.user-pass-form {
  width: 500px;
}
.bind-email {
  margin-left: 50px;
  color: #757575;
}
.bind-email .bind-email-href {
  color: #757575;
  margin-left: 5px;
  margin-right: 5px;
}
.bind-email .bind-email-href:hover {
  color: #C9A227;
}
</style>